import React, {useEffect, useState} from 'react';
import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Stack,
    Step,
    StepLabel,
    Stepper
} from "@mui/material";
import TextFieldWithSetValue from "../../../textfield/TextFieldWithSetValue";
import ButtonExit from "../../../button/ButtonExit";
import ButtonAdd from "../../../button/ButtonAdd";
import {Box} from "@mui/system";
import MaterialPageItemModule from "../../../modul/MaterialPageItemModule";
import ButtonBack from "../../../button/ButtonBack";
import TextFieldValidation from "../../customer-detales/TextFieldValidation";

const ModalCreateOrUpdateDetail = ({
                                       open,
                                       onClose,
                                       title,
                                       initValues,
                                       labelButtonSSubmit,
                                       handleSubmit,
                                       isOptimization,
                                       isReserve,
                                       materialList,
                                       setMaterialId,
                                       handleModalAlert,
                                       isDetailModel,
                                       composition,
                                       loading
                                   }) => {
    const [activeStep, setActiveStep] = useState(0)
    const [materialOptionOrganizationId, setMaterialOptionOrganizationId] = useState(null)
    const [values, setValues] = useState(initValues)
    const [validationState, setValidationState] = useState({position: "", name: "", width: "", length: ""})

    useEffect(() => {
        setValues(initValues)
        setMaterialOptionOrganizationId(initValues?.materialOptionOrganizationId)
    }, [initValues]);

    const close = () => {
        onClose()
        setActiveStep(0)
        setValues(initValues)
        setMaterialOptionOrganizationId(null)
        setValidationState({position: "", name: "", width: "", length: ""})
    }
    const submit = () => {
        if (activeStep === 0 && isReserve) {
            setActiveStep(1)
        } else {
            const newErrors = {...validationState}

            Object.entries(values).forEach(([name, value]) => {

                if (value === "" && ["position", "name", "width", "length"].includes(name)) {
                    newErrors[name] = "пустое поле"
                }
            })

            setValidationState(newErrors)

            if (Object.values(newErrors).every(el => el === "")) {
                handleSubmit(values, close)
            }
        }
    }
    const handleSelectMaterial = (material) => {
        setValues(prev => ({...prev, materialOptionOrganizationId: material.id}))
        setMaterialOptionOrganizationId(material.id)
    }
    return (
        <Dialog open={open} PaperProps={{
            style: {
                minWidth: `${isDetailModel ? "1000px" : (activeStep === 0 && isReserve) ? "1400px" : "300px"}`,
            }
        }}>
            <DialogTitle textAlign="center">{title}</DialogTitle>
            {isReserve &&
                <Box sx={{display: "flex", justifyContent: "center"}}>
                    <Stepper
                        style={{width: 400}}
                        activeStep={activeStep}
                    >
                        {["Материал", "Параметры"].map((label) => (
                            <Step key={label}>
                                <StepLabel sx={{
                                    ".MuiSvgIcon-root": {
                                        fontSize: 40,
                                        color: "#737478",
                                        "&.Mui-active": {
                                            color: "#3B8BEC",
                                        }
                                    },
                                    "& .MuiStepLabel-label": {
                                        fontSize: 18,
                                        "&.Mui-active": {
                                            fontWeight: 700,
                                        }
                                    }
                                }}>{label}</StepLabel>
                            </Step>
                        ))}
                    </Stepper>
                </Box>}
            <DialogContent>
                {(activeStep === 0 && isReserve) ? <MaterialPageItemModule
                        refMaterial={false}
                        pageSize={20}
                        enableEditing={true}
                        isAddMaterial={false}
                        isSelectInArrival={true}
                        isSelectInEstimate={false}
                        modal={true}
                        selectMaterialId={materialOptionOrganizationId}
                        selectMaterial={handleSelectMaterial}
                        handleModalAlert={handleModalAlert}
                    /> :
                    <form onSubmit={(e) => e.preventDefault()}>
                        <Stack
                            sx={{
                                width: '100%',
                                maxHeight: composition ? "650px" : isOptimization ? "750px" : "600px",
                                minWidth: {xs: '300px', sm: '360px', md: '400px'},
                                display: "flex",
                                flexWrap: "wrap",
                                gap: "0 25px"
                            }}
                        >
                            <TextFieldValidation
                                name={"position"}
                                type={"text"}
                                value={values?.position}
                                label={"Позиция"}
                                setCurrValues={setValues}
                                validationError={validationState?.position}
                                setValidationState={setValidationState}
                            />
                            {isDetailModel && <TextFieldWithSetValue
                                label="Серия"
                                values={values}
                                setValues={setValues}
                                field={'modelSeries'}
                            />}
                            <TextFieldValidation
                                name={"name"}
                                type={"text"}
                                value={values?.name}
                                label={"Наименование"}
                                setCurrValues={setValues}
                                validationError={validationState?.name}
                                setValidationState={setValidationState}
                            />
                            {isDetailModel && <TextFieldWithSetValue
                                label="Наименование материала"
                                values={values}
                                setValues={setValues}
                                field={'nameMaterial'}
                            />}

                            {isDetailModel && <TextFieldWithSetValue
                                label="Описание модели"
                                values={values}
                                setValues={setValues}
                                field={'groupModel'}
                            />}
                            <TextFieldValidation
                                name={"width"}
                                type={"text"}
                                value={values?.width}
                                label={"Ширина"}
                                setCurrValues={setValues}
                                validationError={validationState?.width}
                                setValidationState={setValidationState}
                            />
                            <TextFieldValidation
                                name={"length"}
                                type={"text"}
                                value={values?.length}
                                label={"Высота"}
                                setCurrValues={setValues}
                                validationError={validationState?.length}
                                setValidationState={setValidationState}
                            />
                            {composition && <TextFieldValidation
                                name={"height"}
                                type={"text"}
                                value={values?.height}
                                label={"Толщина"}
                                setCurrValues={setValues}
                                validationError={validationState?.height}
                                setValidationState={setValidationState}
                            />}
                            {!isDetailModel && <TextFieldWithSetValue
                                label={isReserve ? "Лимит резерва" : "количество"}
                                values={values}
                                setValues={setValues}
                                field={isReserve ? 'reserveLimit' : 'quantity'}
                            />}
                            {!isReserve && <>
                                <TextFieldWithSetValue
                                    label="l1"
                                    values={values}
                                    setValues={setValues}
                                    field={'l1'}
                                />
                                {isDetailModel && <TextFieldWithSetValue
                                    label="Наименование l1"
                                    values={values}
                                    setValues={setValues}
                                    field={'l1Name'}
                                />}
                                <TextFieldWithSetValue
                                    label="l2"
                                    values={values}
                                    setValues={setValues}
                                    field={'l2'}
                                />
                                {isDetailModel && <TextFieldWithSetValue
                                    label="Наименование l2"
                                    values={values}
                                    setValues={setValues}
                                    field={'l2Name'}
                                />}
                                <TextFieldWithSetValue
                                    label="w1"
                                    values={values}
                                    setValues={setValues}
                                    field={'w1'}
                                />
                                {isDetailModel && <TextFieldWithSetValue
                                    label="Наименование w1"
                                    values={values}
                                    setValues={setValues}
                                    field={'w1Name'}
                                />}
                                <TextFieldWithSetValue
                                    label="w2"
                                    values={values}
                                    setValues={setValues}
                                    field={'w2'}
                                />
                                {isDetailModel && <TextFieldWithSetValue
                                    label="Наименование w2"
                                    values={values}
                                    setValues={setValues}
                                    field={'w2Name'}
                                />}
                                <TextFieldWithSetValue
                                    label="Паз"
                                    values={values}
                                    setValues={setValues}
                                    field={'groove'}
                                />
                            </>}
                        </Stack>
                    </form>}
            </DialogContent>
            <DialogActions style={{padding: 40, display: "flex", justifyContent: "space-between"}}>
                <Box>{activeStep !== 0 && <ButtonBack text={"Назад"} onClick={() => setActiveStep(0)}/>} </Box>
                <Box>
                    <ButtonExit
                        text={"Выйти"} onClick={close}/>
                    <ButtonAdd
                        loading={loading}
                        text={(activeStep === 0 && isReserve) ? "Выбрать" : labelButtonSSubmit}
                        onClick={submit}
                        disabled={!materialOptionOrganizationId && isReserve}
                    />
                </Box>
            </DialogActions>
        </Dialog>
    );
};

export default ModalCreateOrUpdateDetail;